import { ObbAnnotation } from "../../api/Application";
import { DotaV1Class } from "../../ml/Dota";
import { calcRectangle } from "../../common/Geometry";
import { Mode, DrawingStateFns, ModeCreate } from "./ModeContext";

export function createCreateMode( classLabel: DotaV1Class, initialWidth: number ): ModeCreate {
    return { mode: Mode.Create, classLabel: classLabel, initialWidth, rearCenter: undefined };
}

export const createModeFns: DrawingStateFns = {
    getCommandSlots( drawMode ) {
        return [];
    },

    onKeyDown( drawMode, key, shift, ctx ) {        
        function changeWidth( newWidth: number ) {
            ctx.setDrawMode( { ...m, initialWidth: newWidth } );
            if( m.rearCenter !== undefined && m.frontCenter !== undefined ) {
                ctx.setNewPolygon( calcRectangle( m.rearCenter, m.frontCenter, newWidth ) );
            }
        }
        const m = drawMode as ModeCreate;
        if( key === "w" || key === "x" ) { 
            changeWidth( ( m.initialWidth + 0.5 ) );
            return true;
        }
        if( key === "q" || key === "z" ) { 
            changeWidth( ( m.initialWidth - 0.5 ) );
            return true;
        }
        return false;        
    },

    onDeckClick( drawMode, info, ctx ) {
        const mode = drawMode as ModeCreate;
        const lngLat = info.coordinate as [number, number];
        if( !mode.rearCenter ) {
            ctx.setDrawMode( { ...mode, rearCenter: lngLat } );
        }
        else {
            const rear  = mode.rearCenter;
            const front = lngLat;
            const cx = ( rear[0] + front[0] ) / 2;
            const cy = ( rear[1] + front[1] ) / 2;
            const dx = front[0] - rear[0];
            const dy = front[1] - rear[1];
            const length = Math.sqrt( dx * dx + dy * dy );
            const angle  = ( Math.atan2( dy, dx ) * 180 ) / Math.PI;
            const annotation: Partial<ObbAnnotation> = {
                x:      cx / ctx.imageWidth,
                y:      cy / ctx.imageHeight,
                width:  length / ctx.imageWidth,
                height: mode.initialWidth / ctx.imageHeight,
                angle,
                attributes: {
                    classLabel:  mode.classLabel,
                    vehicleType: null,
                    color:       null,
                    parts:       [],
                    shade:       null,
                    occluded:    null,
                    rare:        null,
                }
            };
            ctx.handleAdd( annotation as ObbAnnotation );
            ctx.setNewPolygon( [] );
            ctx.setDrawMode( { mode: Mode.Inactive } ); //back to inactive
        }
    },

    onDeckHover( drawMode, info, ctx ) {
        const mode = drawMode as ModeCreate;
        if( mode.rearCenter ) {
            const rear  = mode.rearCenter;
            const front = info.coordinate as [number, number];            
            if( front === undefined || rear === undefined ) {
                return;
            }
            ctx.setDrawMode( { ...mode, frontCenter: front } );
            const poly = calcRectangle( rear, front, mode.initialWidth );
            ctx.setNewPolygon( poly );
        }
    },

    onAnnotationClick( drawMode, ann, ctx ) {
        //nothing to do...
    },

    filter( mode, ann ) {
        return true;
    },
    
    getLineColor( drawMode, ann, ctx ) {
        const { obbAnnotationId: id, attributes: attrs } = ann;
        const done  = !( attrs.color === null || attrs.vehicleType === null );
        const alpha = id == ctx.hovObj?.obbAnnotationId ? 224 : 160;
        if( !done    ) { return [ 255, 255, 0, alpha ]; } //bright yellow
        if(  done    ) { return [   0, 255, 0, alpha ]; } //bright green
        return [255, 0, 0, 255];
    },

    getCursor( drawMode ) {
        return "crosshair";
    },

    getAnnotationLabel( drawMode, ann ) {
        return "";
    }
};